
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_4079j_97",
  "root-fit-height": "awsui_root-fit-height_14iqq_4079j_110",
  "variant-default": "awsui_variant-default_14iqq_4079j_116",
  "variant-stacked": "awsui_variant-stacked_14iqq_4079j_116",
  "header": "awsui_header_14iqq_4079j_139",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_4079j_144",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_4079j_148",
  "header-stuck": "awsui_header-stuck_14iqq_4079j_154",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_4079j_159",
  "with-paddings": "awsui_with-paddings_14iqq_4079j_165",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_4079j_168",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_4079j_172",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_4079j_196",
  "dark-header": "awsui_dark-header_14iqq_4079j_214",
  "content": "awsui_content_14iqq_4079j_218",
  "footer": "awsui_footer_14iqq_4079j_229",
  "with-divider": "awsui_with-divider_14iqq_4079j_232"
};
  